import { ReactText, useState } from 'react';
import { t } from 'utilities/TranslationUtils';

// components
import { Select } from '@trackman/web-shared-components';
import { AppButton } from 'components/form';

// types
import { SelectChangeEvent } from '@mui/material';

type SelectFilterProps = {
  filter: { options: any[]; type: string; selectProps?: any; label?: string };
  onApply: (value?: any) => void;
};

export const SelectFilter = ({ filter, onApply }: SelectFilterProps) => {
  const [value, setValue] = useState<string | number>('');

  return (
    <div className='data-table-filter-content gap-10px'>
      <Select
        label={filter?.label ?? ''}
        value={value ?? ''}
        selectOptions={filter?.options || []}
        onKeyDown={(e) => e.key === 'Enter' && onApply(value)}
        onChange={(event, child) => {
          setValue(event.target.value as ReactText);
        }}
      />

      <AppButton
        data-test='ApplySelectFilterSubmit'
        type='button'
        className='apply-button '
        variant='primary'
        onClick={() => onApply(value)}
      >
        {t('common.apply')}
      </AppButton>
    </div>
  );
};

export default SelectFilter;
